import React, { Suspense } from 'react';
import { Hero } from './components/Hero';
import { Pain } from './components/Pain';
import { Revelation } from './components/Revelation';

// Lazy load below-the-fold components to improve initial load speed
const Benefits = React.lazy(() => import('./components/Benefits').then(m => ({
  default: m.Benefits
})));
const ValueStack = React.lazy(() => import('./components/ValueStack').then(m => ({
  default: m.ValueStack
})));
const Testimonials = React.lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const Guarantee = React.lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const Objections = React.lazy(() => import('./components/Objections').then(m => ({
  default: m.Objections
})));
const FinalCTA = React.lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = React.lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopups = React.lazy(() => import('./components/SocialProofPopups').then(m => ({
  default: m.SocialProofPopups
})));
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-50 font-sans selection:bg-amber-500/30" data-id="element-0" data-mp="3mjpyb4i388ps">
      <Hero data-id="element-1" data-mp="3rd191gq0t9mz" />
      <Pain data-id="element-2" data-mp="3reltgdimfc74" />
      <Revelation data-id="element-3" data-mp="5yhupa6n3cr" />
      <Suspense fallback={<div className="min-h-screen bg-zinc-950" data-id="element-5" data-mp="4ww9qvjiygs" />} data-id="element-4" data-mp="6hpnd64cbd2">
        <Benefits data-id="element-6" data-mp="2zl3alhpbj03q" />
        <ValueStack data-id="element-7" data-mp="2zllen0i82im7" />
        <Testimonials data-id="element-8" data-mp="2zm4xcjfp5b1a" />
        <Guarantee data-id="element-9" data-mp="2zmwi0z7r9ocs" />
        <Objections data-id="element-10" data-mp="2zng0ch1bierc" />
        <FinalCTA data-id="element-11" data-mp="33mf0loc3tncg" />
        <Footer data-id="element-12" data-mp="33lx0ggmbmoz9" />
        <SocialProofPopups data-id="element-13" data-mp="33ngfk3w8qtzg" />
      </Suspense>
    </div>;
}